<template>
    <div :id="id" style="height: 400px; overflow: hidden; text-align: left;"></div>
</template>
<script>
  /* ============
   * LineArea Component
   * ============
   *
   * LineAndAreaChart
   */
  import _ from 'lodash'

  export default {
    props: {
      options: Object
    },
    data () {
      return {
        id: null
      }
    },
    methods: {
      updateData (data) {
        this.chart.dataProvider = data
        this.chart.validateData()
        this.chart.animateAgain()
      }
    },
    created () {
      this.id = _.uniqueId('chart_')
    },
    mounted () {
      this.chart = window.AmCharts.makeChart(this.id, this.options)
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/charts/LineArea.vue